import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';
import { AuthStore } from '@domains/auth/auth.store';

/**
 * Holds a freshly signed-up user on `/additional-info` until their account details
 * are in (`account_setup_required`). Runs alongside authGuard, so it waits for the
 * session the same way.
 */
export const accountSetupGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const check = () =>
    authStore.currentUser()?.account_setup_required ? router.parseUrl('/additional-info') : true;

  if (!authStore.isLoading()) return check();

  return toObservable(authStore.isLoading).pipe(
    filter((loading) => !loading),
    take(1),
    map(check),
  );
};
